module.exports = __webpack_public_path__ + "img/img105.0bd8c69c.svg";